

































import Vue from "vue";
import OrderOverview from "@/views/client/OrderOverview.vue";
import {
  GET_ORDER_DISH,
  GET_ORDER_STATUS,
} from "@/queries/customer/query.graphql";
import router from "@/router";
import { apolloClient } from "@/apollo";
import store from "@/store";
import { GET_TABLE } from "@/queries/customer/mutation.graphql";
export default Vue.extend({
  beforeRouteEnter(to, from, next) {
    apolloClient
      .query({
        query: GET_ORDER_STATUS,
        variables: {
          id: store.getters["authModule/orderId"],
        },
      })
      .then(({ data: { Order } }) => {
        console.log(Order);
        store.commit("loadersModule/toggleGlobalLoader", false);
        if (Order[0].status === "ORDERING") {
          next(
            from.matched.length > 0
              ? from.fullPath
              : { name: "menu-for-customer", params: { ...to.params } }
          );
        } else {
          next();
        }
      });
  },
  data() {
    return {
      isMobile: null,
      orders: [],
      orderInfo: {},
      tableInfo: null,
    };
  },
  apollo: {
    orders: {
      query: GET_ORDER_DISH,
      update: (data: any) => data.OrderDish,
    },
    orderInfo: {
      query: GET_ORDER_STATUS,
      update: (data: any) => data.Order[0],
    },
  },
  components: {
    OrderOverview,
  },
  computed: {
    tableType() {
      return this.$route.params.tableId === "generic" ? "generic" : "table";
    },
  },
  methods: {
    status(st) {
      if (this.$apollo.queries.orderInfo.loading) {
        return "";
      }
      const obj = {
        ORDERED_NOT_PAID: {
          generic: `Please pay for your order at the counter.`,
          table: `Please wait till the waiter comes and collects your payment.`,
        },
        ORDERED_PAID_ONLINE: {
          generic: `Please pick up your order at the counter.`,
          table: `Your order will be delivered to you.`,
        },
      };
      return obj[st][this.tableType];
    },
    checkSize() {
      if (window.innerWidth > 992) {
        this.isMobile = false;
        return;
      }
      this.isMobile = true;
    },
    startNewOrder() {
      this.$store.commit("authModule/reintiateOrder");
      const url = location.href.replace(/complete/, "menu");
      //location.assign(url);
      window.open(url);
    },
  },
  mounted() {
    this.checkSize();
    (async () => {
      if (this.tableType === "table") {
        const {
          data: { Table },
          errors,
        } = await this.$apollo.query({
          query: GET_TABLE,
          variables: {
            tableId: this.$route.params.tableId,
          },
        });
        if (Table && Table.length) {
          this.tableInfo = Table[0];
        }
        console.log(Table);
      }
    })();
  },
  created() {
    window.addEventListener("resize", this.checkSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkSize);
  },
});
